import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled(Box)<{
  columns: number
  gap: number | string
  marginTop?: number
  marginBottom?: number
}>(
  ({ theme, columns, gap, marginTop, marginBottom }) => css`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(${columns}, 1fr);
    gap: ${typeof gap === 'number' ? `${gap}px` : gap};
    margin-top: ${marginTop ? `${marginTop}px` : 0};
    margin-bottom: ${marginBottom ? `${marginBottom}px` : 0};

    @media (max-width: ${theme.screenSizes.laptop}) {
      grid-template-columns: 1fr;
    }
  `
)
